module.exports = __webpack_public_path__ + "static/headphones-banner-parallax-section-2942ea58597e513a071cbbcd14b47275.png";